import { render } from "./SidebarRow.vue?vue&type=template&id=469b0700&scoped=true"
import script from "./SidebarRow.vue?vue&type=script&lang=js"
export * from "./SidebarRow.vue?vue&type=script&lang=js"

import "./SidebarRow.vue?vue&type=style&index=0&id=469b0700&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-469b0700"]])

export default __exports__